export const SET_PAGE_LOADING = 'SetPageLoading';
export const SET_HAS_ACTION_RIBBON = 'SetHasActcionRibbon';
export const SET_CURRENT_ERROR = 'SetError';
export const SET_APP_CONFIGS = 'SetAppConfigs';
